<template>
    <div>
        <!--=====================================-->
        <!--=       Experts  Area Start        =-->
        <!--=====================================-->
        <section class="section section-padding expert-counterup-area">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-2 offset-xl-2">
                        <div class="section-heading heading-left">
                            <span class="subtitle emerge-red bold">EMERGE.</span>
                            <h2>Metas <br>a <span class="bold">2024.</span></h2>
                        </div>
                    </div>
                    <div class="col-lg-5 offset-xl-1">
                        <div class="row" id="no-equal-gallery">
                            <div class="col-sm-6 no-equal-item" data-sal="slide-up" data-sal-duration="800" data-sal-delay="100">
                                <div class="counterup-progress counterup-progress-emerge">
                                    <div class="icon">
                                        <img class="dark-icon" :src="`${imgBaseBlack}01.png`" alt="dark">
                                        <img class="light-icon" :src="`${imgBaseRed}01.png`" alt="light">
                                    </div>
                                    <div class="count-number h2">
                                        <span class="number count" data-count="250">250</span>
                                    </div>
                                    <h6 class="title black mb-0">Instalaciones de sistemas solares</h6>
                                    <p class="black font-1x">financiados e instalados en los negocios locales minoristas.</p>
                                </div>
                            </div>
                            <div class="col-sm-6 mt--90 mt_md--0 no-equal-item" data-sal="slide-up" data-sal-duration="800" data-sal-delay="200">
                                <div class="counterup-progress counterup-progress-emerge">
                                    <div class="icon">
                                        <img class="dark-icon" :src="`${imgBaseBlack}02.png`" alt="Icon">
                                        <img class="light-icon" :src="`${imgBaseRed}02.png`" alt="Icon">
                                    </div>
                                    <div class="count-number h2">
                                        <span class="number count" data-count="200">200</span>
                                    </div>
                                    <h6 class="title black mb-0">Negocios minoristas capacitados</h6>
                                    <p class="black font-1x">en aspectos técnicos y financieros
                                        de generación distribuida
                                        y eficiencia energética.
                                    </p>
                                </div>
                            </div>
                            <div class="col-sm-6 no-equal-item fix-card" data-sal="slide-up" data-sal-duration="800" data-sal-delay="300">
                                <div class="counterup-progress counterup-progress-emerge">
                                    <div class="icon">
                                        <img class="dark-icon" :src="`${imgBaseBlack}03.png`" alt="Icon">
                                        <img class="light-icon" :src="`${imgBaseRed}03.png`" alt="Icon">
                                    </div>
                                    <div class="count-number h2">
                                        <span class="number count" data-count="40">40</span>
                                    </div>
                                    <h6 class="title black mb-0">Instaladores solares
                                        de pequeña escala
                                        capacitados</h6>
                                    <p class="black font-1x">para fortalecer y ampliar sus operaciones.</p>
                                </div>
                            </div>
                            <div class="col-sm-6 no-equal-item" data-sal="slide-up" data-sal-duration="800" data-sal-delay="400">
                                <div class="counterup-progress counterup-progress-emerge">
                                    <div class="icon">
                                        <img class="dark-icon" :src="`${imgBaseBlack}04.png`" alt="Icon">
                                        <img class="light-icon" :src="`${imgBaseRed}04.png`" alt="Icon">
                                    </div>
                                    <div class="count-number h2">
                                        <span class="number count" data-count="64">2,450</span>
                                    </div>
                                    <h6 class="title black mb-0">Toneladas de emisiones de CO2 evitadas</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        data: () => ({
            imgBaseBlack: "https://cdn.redgirasol.com/nuevo_portal/emerge/icons/icon-black-",
            imgBaseRed: "https://cdn.redgirasol.com/nuevo_portal/emerge/icons/icon-red-",
        }),
    }
</script>


<style>

.fix-card {
    margin-top: -6.5rem;
}

@media (max-width: 750px){
    .fix-card {
        margin-top: auto;
    }
}


.counterup-progress.counterup-progress-emerge {
    border: 3px solid var(--color-emerge);
    background-color: var(--color-white);
}
.counterup-progress.counterup-progress-emerge p {
    line-height: 1;
    margin-bottom: 0;
    margin-top: 5px;
}
    .counterup-progress-emerge span {
        color: var(--color-emerge);
        font-weight: bold;
    }
        .counterup-progress-emerge:hover span {
            color: var(--color-white);
        }
        .counterup-progress-emerge:hover .dark-icon {
            display: block;
        }
        .counterup-progress-emerge:hover .light-icon {
            display: none;
        }
    .counterup-progress-emerge h6 {
        color: var(--color-black);
    }

    .counterup-progress-emerge .dark-icon {
        display: none;
    }
    .counterup-progress-emerge .light-icon {
        display: block;
    }

.counterup-progress.counterup-progress-emerge:hover {
    color: var(--color-white);
    background: var(--color-emerge);
}

.icon {
    text-align: -webkit-center;
}

</style>